import React from 'react';
import { Box, Text } from '@common-fe/common-fe';


interface Props {
  children?: React.ReactNode;
}
const EnrollmentInvestmentsWrapper: React.FC<Props> = ({ children }) => {
  return (
    <Box
      pad="spacing24"
      background="canvas"
      round="container1Round"
      border={{ size: '1px', color: 'border2' }}
      gap="spacing16"
      direction="column"
    >
      <Box direction="row" align="center" height="28px">
        <Text size="xxlarge" weight={400}>
          Investments status
        </Text>
      </Box>

      <Box direction="row">{children}</Box>
    </Box>
  );
};

export default EnrollmentInvestmentsWrapper;
